import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[520px] md:h-[640px] w-full flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20beauty%20spa%20and%20salon%20interior%20with%20soft%20warm%20candlelight%20ambiance%2C%20luxurious%20cream%20and%20beige%20color%20palette%2C%20fresh%20flowers%20arrangement%2C%20serene%20relaxing%20atmosphere%2C%20modern%20minimalist%20design%20with%20natural%20elements%2C%20professional%20wellness%20center%20setting&width=1600&height=900&seq=91mei-hero-01&orientation=landscape"
        alt="91美 - 您值得信赖的美业服务平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      <div className="relative z-10 w-full max-w-[800px] mx-auto text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl text-white mb-5 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-sm md:text-base text-white/85 mb-8 max-w-[600px] mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
          <Link
            to="/categories"
            className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-md font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {t('hero.ctaExplore')}
          </Link>
          <Link
            to="/about"
            className="bg-white/15 backdrop-blur-sm hover:bg-white/25 text-white border border-white/30 px-8 py-3 rounded-md font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {t('hero.ctaAbout')}
          </Link>
        </div>
      </div>
    </section>
  );
}